<template>
  <div>
    <a v-for="(link, index) in value" :key="index" :href="link.target" :class="{'focus': link.focus}">{{ link.name }}</a>
  </div>
</template>

<script>

export default {
  name: "featured-links",
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
</script>